(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["inskin-design-system"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('inskin-scene')) {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const desktop = window.matchMedia('(min-width: 990px)');
  const movingScenes = new Set();
  let frame = 0;
  const updateMovement = () => {
    frame = 0;
    movingScenes.forEach(scene => {
      if (!scene.isConnected || reduced.matches || !desktop.matches) return;
      const rect = scene.getBoundingClientRect();
      const progress = Math.max(-1, Math.min(1, (window.innerHeight / 2 - rect.top - rect.height / 2) / (window.innerHeight / 2 + rect.height / 2)));
      scene.style.setProperty('--ik-progress', progress.toFixed(4));
    });
  };
  const requestMovement = () => {
    if (!frame && movingScenes.size) frame = requestAnimationFrame(updateMovement);
  };
  window.addEventListener('scroll', requestMovement, {passive: true});
  window.addEventListener('resize', requestMovement, {passive: true});

  class InskinScene extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.resizeFrames = new Set();
      const signal = this.controller.signal;
      this.motionChange = () => this.setupMotion();
      reduced.addEventListener('change', this.motionChange, {signal});
      desktop.addEventListener('change', this.motionChange, {signal});
      queueMicrotask(() => {
        if (!this.isConnected) return;
        this.setupMotion();
        this.setupRails(signal);
        this.setupVideos(signal);
      });
    }

    setupMotion() {
      this.reveals?.disconnect();
      this.visibility?.disconnect();
      movingScenes.delete(this);
      const elements = [...this.querySelectorAll('[data-reveal]')];
      elements.forEach(element => element.classList.remove('ik-waiting', 'ik-revealed'));
      if (reduced.matches || this.dataset.motion !== 'true' || window.Shopify?.designMode) return;
      if ('IntersectionObserver' in window) {
        this.reveals = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            entry.target.classList.remove('ik-waiting');
            entry.target.classList.add('ik-revealed');
            this.reveals.unobserve(entry.target);
          });
        }, {threshold: 0.08, rootMargin: '0px 0px -20px 0px'});
        elements.forEach((element, index) => {
          const rect = element.getBoundingClientRect();
          if (rect.top > window.innerHeight + 20) {
            element.classList.add('ik-waiting');
            element.style.setProperty('--ik-delay', `${Math.min(index % 3, 2) * 55}ms`);
            this.reveals.observe(element);
          }
        });
        if (this.dataset.imageMotion === 'true' && desktop.matches && this.querySelector('[data-depth]')) {
          this.visibility = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              if (entry.isIntersecting) movingScenes.add(this);
              else movingScenes.delete(this);
            });
            requestMovement();
          }, {rootMargin: '100px'});
          this.visibility.observe(this);
        }
      }
    }

    setupRails(signal) {
      this.querySelectorAll('[data-rail]').forEach(rail => {
        const controls = rail.nextElementSibling?.matches('[data-rail-controls]') ? rail.nextElementSibling : null;
        if (!controls) return;
        const previous = controls.querySelector('[data-rail-prev]');
        const next = controls.querySelector('[data-rail-next]');
        const count = controls.querySelector('[data-rail-count]');
        let scheduled = 0;
        const update = () => {
          this.resizeFrames.delete(scheduled);
          scheduled = 0;
          const overflow = rail.scrollWidth > rail.clientWidth + 5;
          controls.hidden = !overflow;
          rail.tabIndex = overflow ? 0 : -1;
          previous.disabled = rail.scrollLeft <= 3;
          next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4;
          if (overflow) {
            const children = [...rail.children];
            const bounds = rail.getBoundingClientRect();
            let nearest = 0;
            let distance = Infinity;
            children.forEach((child, index) => {
              const delta = Math.abs(child.getBoundingClientRect().left - bounds.left);
              if (delta < distance) {distance = delta; nearest = index;}
            });
            if (next.disabled) nearest = children.length - 1;
            const value = `${nearest + 1} / ${children.length}`;
            if (count.textContent !== value) count.textContent = value;
          }
        };
        const schedule = () => {
          if (!scheduled) {
            scheduled = requestAnimationFrame(update);
            this.resizeFrames.add(scheduled);
          }
        };
        const move = direction => {
          const child = rail.firstElementChild;
          if (!child) return;
          const gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
          rail.scrollBy({left: direction * (child.getBoundingClientRect().width + gap), behavior: reduced.matches ? 'instant' : 'smooth'});
        };
        previous.addEventListener('click', () => move(-1), {signal});
        next.addEventListener('click', () => move(1), {signal});
        rail.addEventListener('scroll', schedule, {signal, passive: true});
        rail.addEventListener('keydown', event => {
          if (event.target !== rail || controls.hidden) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            move(event.key === 'ArrowRight' ? 1 : -1);
          }
        }, {signal});
        if ('ResizeObserver' in window) {
          const observer = new ResizeObserver(schedule);
          observer.observe(rail);
          this.railObservers ||= [];
          this.railObservers.push(observer);
        } else window.addEventListener('resize', schedule, {signal, passive: true});
        update();
      });
    }

    setupVideos(signal) {
      this.videos = [...this.querySelectorAll('video')];
      const play = video => {
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');
        video.setAttribute('loop', '');
        if (reduced.matches || document.hidden) {
          video.pause();
          video.controls = true;
          return;
        }
        const pending = video.play();
        if (pending) pending.then(() => {video.controls = false;}).catch(() => {video.controls = true;});
      };
      if ('IntersectionObserver' in window && this.videos.length) {
        this.videoObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            entry.target.dataset.ikVisible = String(entry.isIntersecting);
            if (entry.isIntersecting) play(entry.target);
            else entry.target.pause();
          });
        }, {threshold: 0.1});
        this.videos.forEach(video => this.videoObserver.observe(video));
      } else this.videos.forEach(play);
      const sync = () => this.videos.forEach(video => {
        if (document.hidden || reduced.matches || video.dataset.ikVisible === 'false') {
          video.pause();
          if (reduced.matches) video.controls = true;
        }
        else play(video);
      });
      document.addEventListener('visibilitychange', sync, {signal});
      reduced.addEventListener('change', sync, {signal});
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.reveals?.disconnect();
      this.visibility?.disconnect();
      this.videoObserver?.disconnect();
      this.railObservers?.forEach(observer => observer.disconnect());
      this.railObservers = [];
      this.resizeFrames?.forEach(cancelAnimationFrame);
      this.videos?.forEach(video => video.pause());
      movingScenes.delete(this);
    }
  }
  customElements.define('inskin-scene', InskinScene);
}
  } catch(e) { console.error(e); }
})();

})();
